import CONSTANTS from "./constants";
import BaseHttpHandler from "./utilities/baseHttpHandler";

async function getPermissions() {
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.get(
      CONSTANTS.API_CONSTANTS.ENDPOINTS.ACCOUNT_PERMISSIONS,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    // If the Account/Permissions endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

export default { getPermissions };
